import React from 'react';
import { AbsoluteFill } from 'remotion';
import { ThemeSystemConfig } from '../../clipCreator/remotion/Components/Theme/Theme';
import { AspectRatio } from '../AspectRatio';
import { TimelineDefaults } from '../TimelineDefaults';
import { TextOverlayItem, TextOverlayItemImpl } from '../types';
import { LayerContainer } from './types';

export class TextOverlayLayerContainer implements LayerContainer {
    items: TextOverlayItem[];

    constructor(items: Omit<TextOverlayItem, 'render' | 'mediaObject'>[]) {
        this.items = items.map(item => new TextOverlayItemImpl(item));
    }

    render(fps: number, theme: ThemeSystemConfig, aspectRatio: AspectRatio, defaults: TimelineDefaults, videoConfig?: { width: number; height: number }): React.ReactNode {
        return (
            <AbsoluteFill style={{ pointerEvents: 'none' }}>
                {this.items.map(item => (
                    <div key={item.id} style={{ position: 'absolute', width: '100%', height: '100%', pointerEvents: 'none' }}>
                        {item.render(fps, theme, aspectRatio, defaults, videoConfig)}
                    </div>
                ))}
            </AbsoluteFill>
        );
    }
} 